<template>
  <img
    v-if="media"
    :alt="media.data?.alt ?? undefined"
    loading="lazy"
    :src="media.original"
    :srcset="srcset"
    :title="media.data?.title ?? undefined"
  />
</template>

<script lang="ts">
import type { PropType } from 'vue'

const RESOLUTIONS = {
  lg: 1920,
  sm: 800,
  md: 768,
  tb: 150,
} as { [key: string]: number }

export default {
  name: 'ResponsiveImage',
  props: {
    media: {
      type: Object as PropType<Media | null>,
      default: null,
    },
  },
  computed: {
    srcset() {
      if (!this.media) return undefined

      const resolutions = Object.keys(RESOLUTIONS)
      return Object.entries(this.media)
        .filter(([key]) => resolutions.includes(key))
        .toSorted((srcA, srcB) => RESOLUTIONS[srcA[0]] - RESOLUTIONS[srcB[0]])
        .map((src) => `${src[1]} ${RESOLUTIONS[src[0]]}w`)
        .join(', ')
    },
  },
}
</script>
